import { createApp } from 'vue'

import App from './App.vue'
import store from './store'
import router from './router'
import VueTheMask from 'vue-the-mask'
import VueMixpanel from 'vue-mixpanel'
import _filters from './utils/filters'
import * as VeeValidate from 'vee-validate'
import baseToast from './plugins/baseToast/'

// import _env from './_env'
import './libs/veevalidate.js'
import './styles/scss/main.scss'
import './styles/css/spinner.css'

const app = createApp(App)
app.config.globalProperties.$filters = _filters

app.use(VueMixpanel, {
  token: '2f1cb4f511d6b25c6b50130de1c5de78',
  config: {
    debug: true
  }
})

app.use(store).use(router).use(baseToast).use(VueTheMask).use(VeeValidate).mount('#app')
